import { render, staticRenderFns } from "./pagination.vue?vue&type=template&id=249fd638&"
import script from "./pagination.vue?vue&type=script&lang=js&"
export * from "./pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports